const SET_SHELTERT_NAME = 'SET_SHELTERT_NAME';
const SET_YEAR_LIST = 'SET_YEAR_LIST';
const SET_KOJIN_INFO = 'SET_KOJIN_INFO';
const SET_SETAI_INFO = 'SET_SETAI_INFO';
const SET_KOJIN_INFO_DETAIL = 'SET_KOJIN_INFO_DETAIL';

export default {
  SET_SHELTERT_NAME,
  SET_YEAR_LIST,
  SET_SETAI_INFO,
  SET_KOJIN_INFO,
  SET_KOJIN_INFO_DETAIL
};
